import "./bundle-page.scss";

(function () {
    if (document.querySelectorAll(".js-bundle-page").length > 0) {

        const bundlePage = {
            init: function () {
                this.slidePackages();

                const param = window.location.hash;
                const slide1 = document.getElementById("bundle__slide--1");
                const slide2 = document.getElementById("bundle__slide--2");
                const slide3 = document.getElementById("bundle__slide--3");

                if (param == "#bundle__slide--1") {
                    if (slide1 != null) {
                        slide1.querySelector(".bundle__slide--body").classList.add("bundle_visible");
                        slide1.querySelector(".bundle__slide--body").classList.remove("bundle_hide");
                    }

                    if (slide2 != null) {
                        slide2.querySelector(".bundle__slide--body").classList.add("bundle_hide");
                        slide2.querySelector(".bundle__slide--body").classList.remove("bundle_visible");
                    }

                    if (slide3 != null) {
                        slide3.querySelector(".bundle__slide--body").classList.add("bundle_hide");
                        slide3.querySelector(".bundle__slide--body").classList.remove("bundle_visible");
                    }
                }
                if (param == "#bundle__slide--2") {
                    if (slide2 != null) {
                        slide2.querySelector(".bundle__slide--body").classList.add("bundle_visible");
                        slide2.querySelector(".bundle__slide--body").classList.remove("bundle_hide");
                    }

                    if (slide3 != null) {
                        slide3.querySelector(".bundle__slide--body").classList.add("bundle_hide");
                        slide3.querySelector(".bundle__slide--body").classList.remove("bundle_visible");
                    }
                }
                if (param == "#bundle__slide--3") {
                    if (slide3 != null) {
                        slide3.querySelector(".bundle__slide--body").classList.add("bundle_visible");
                        slide3.querySelector(".bundle__slide--body").classList.remove("bundle_hide");
                    }
                    
                    if (slide2 != null) {
                        slide2.querySelector(".bundle__slide--body").classList.add("bundle_hide");
                        slide2.querySelector(".bundle__slide--body").classList.remove("bundle_visible");
                    }
                }

            },
            slidePackages: () => {
                const slider = document.querySelector(".js-bundle-slider");
                const slidePrev = slider.querySelectorAll(".js-bundle-prev");
                const slideNext = slider.querySelectorAll(".js-bundle-next");

                slidePrev.forEach((prevButton) => {
                    prevButton.addEventListener("click", () => {
                        const sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider-index"));

                        slider.style.setProperty("--slider-index", sliderIndex - 1);
                    })
                });

                slideNext.forEach((nextButton) => {
                    nextButton.addEventListener("click", () => {
                        const sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider-index"));

                        slider.style.setProperty("--slider-index", sliderIndex + 1);
                    })
                });
            }
        };

        bundlePage.init();
    }
})();

// TODO: this should be bound with script instead of inline
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function hideBody_slide(showslide, hideslide) {
    const Showdiv = document.getElementById(showslide);
    const hidediv = document.getElementById(hideslide);
    hidediv.querySelector(".bundle__slide--body").classList.add("bundle_hide");
    hidediv.querySelector(".bundle__slide--body").classList.remove("bundle_visible");
    Showdiv.querySelector(".bundle__slide--body").classList.add("bundle_visible");
    Showdiv.querySelector(".bundle__slide--body").classList.remove("bundle_hide");
}
